import styled, { css } from 'styled-components';

import { FloatingLabelInput } from 'components/floating-label-fields';

import { marginLeft } from './constants';

export const AddressList = styled.div`
  margin: 2rem 0;
`;

const newDeliveryStyles = css`
  margin-top: -1px; // for overlapping borders
  border-right: 0;
  border-left: 0;
  justify-content: center;
  border-radius: 0;
`;

export const AddressContainer = styled.label<{ enableSimplifiedDelivery: boolean }>`
  width: 100%;
  margin-top: 1rem;
  padding: 1rem;
  border-radius: ${Styles.borderRadius};
  border: 1px solid ${Styles.color.grey.four};
  display: flex;
  align-items: center;
  cursor: pointer;

  ${props => props.enableSimplifiedDelivery && newDeliveryStyles}

  & > div:first-of-type {
    position: relative;
    margin-left: ${marginLeft};
  }
`;

export const AddressInstructions = styled(FloatingLabelInput)`
  margin-top: 0;
  margin-bottom: 2rem;
`;

export const AddressDetails = styled.div<{ enableSimplifiedDelivery: boolean }>`
  margin-left: 1rem;
  ${props =>
    props.enableSimplifiedDelivery &&
    css`
      // center the address (so option checkbox is off-center)
      margin-right: 40px;
      width: 10rem;
    `}
`;

export const AddressDetailsHeader = styled.div`
  font-weight: bold;
  font-family: ${Styles.fontFamily.body};
`;
